const apiUrl = process.env.VUE_APP_API_URL
import axios from 'axios'
export default {
    async UpdateProfile({ commit }, payLoad) {
        try {
            commit('setLoading', true)
            let data = await axios.put(
                apiUrl + 'system-users/update-profile/' + payLoad._id,
                payLoad,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )

            return data
        } catch ({ response }) {
            return response
        }
    },
}
